const OnBoardPage = () => (
  <section>
    <h1>Onboard</h1>
    <p>
      On board an OpenAPI specification into Secure Cloud Gateway from a guided
      onboarding flow.
    </p>
  </section>
);

export default OnBoardPage;
